import React from "react";

function Molecular_report() {
    return (

        <div style={{ textAlign: "center", marginTop: "120px", color: "#555" }}>
            <h2>📄 Documents Pending</h2>
            <p style={{ fontSize: "16px", marginTop: "10px" }}>
                Some required documents are still pending from your side.
            </p>
            <p style={{ fontSize: "14px", color: "#888" }}>
                Please provide Molecular report documents to continue working with the Molecular report       </p>
        </div>
    );
}

export default Molecular_report;